export default "__VITE_ASSET__O$tNWVyV__"